module.exports = __webpack_public_path__ + "img/deodorizer.05493a32.svg";